import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function useFormatDate() {
  const { i18n } = useTranslation();

  return useCallback(
    (date) => {
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      return dateObj.toLocaleDateString(i18n.language, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
    [i18n.language],
  );
}
